import React from 'react';
import BasketPaxDetails from './basketPaxDetails';
import BasketBooking from './basketbooking';
import { LOCKOUT_MESSAGES } from '../../config';
import ImageSlider from '../shared/image-slider';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(AdvancedFormat);

let BasketDeparture = props => {

  const characterLength = str => {
    return (str && str.length > 44) ? 'small-text' : ''
  }

  const renderStandardOrCyaoPriceMessage = (props) => {
    if(!props.iscyoa){
      return (
        <p className="bold component-spacing">Price from <span className="orange-text">{props.headerCurrency}{props.headerPrice}</span> per person.</p>
      )
    }else if (props.sequenceNrTrips>0) {
      return (
        <p className="margin-b-50">
          <svg className="" width="12" height="12" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
          <path fill="#3ABCCB" d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"></path>
          </svg>
          <strong className="blue-text">{props.sequenceSubName}</strong> - {props.sequenceDays} days trip departing on {dayjs(props.departureDate).format("Do MMMM YYYY")}
        </p>
      )
    }else {
      return (
        <p className="margin-b-50"><strong className="orange-text">{props.sequenceSubName}</strong> - {props.sequenceDays} days trip departing on {dayjs(props.departureDate).format("Do MMMM YYYY")}
        </p>
      )
    }
  }

  return (
    <React.Fragment>
      <div className="lockout-box" style={{display: props.lockout ? "block" : "none" }}>
        <h5 className="orange-text text-initial"><span className="ba-icon ba_icon_extra_info_alt"></span>{LOCKOUT_MESSAGES['passengerDetailsTitle']}</h5>
        <p className="no-margin" dangerouslySetInnerHTML={{ __html:LOCKOUT_MESSAGES['passengerDetailsText'] }}></p>
      </div>

      <div className={`basket-departure ${props.basketType}`}>
        <h4 className={`busabout-h4 uppercase no-margin ${characterLength(props.headerText)}`}>{props.headerText}</h4>
        {renderStandardOrCyaoPriceMessage(props)}

        <div className="row">
          <div className="column small-12 medium-6">

              <div className="image-box">

                <ImageSlider images={props.sliderImages} iscyoa={props.iscyoa}/>

                <div className="benefits-text">
                  <p className="bold">Benefits of Booking with Busabout</p>
                  <ul>
                    <li>We never cancel a trip and do not operate a minimum number policy. When you book one of our trips you are absolutely guaranteed to go.</li>
                    <li>Discount for groups, past passengers and multi-trip.</li>
                    <li>Flexible discount and instant booking confirmation.</li>
                    <li>Secure online booking and management </li>
                  </ul>
                </div>
              </div>

          </div>
          <div className="column small-12 medium-6">
            <BasketPaxDetails nationality={props.nationality} basketType={props.basketType} />
            <BasketBooking basketType={props.basketType} iscyoa={props.iscyoa}/>
          </div>
        </div>

      </div>
    </React.Fragment>
  )
}

export default BasketDeparture;



// WEBPACK FOOTER //
// ./src/components/departure/basketdeparture.js